import React, { useState, useEffect } from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom"; // [EXPERT_COMMENT]: Importación de componente - Se importa 'Outlet' para renderizar las rutas hijas anidadas.
import { fetchWithAuth, API_URL } from "./fetchWithAuth";
import Menu from "../Menu"; // [EXPERT_COMMENT]: Importación de componente - Se importa el componente Menu para ser renderizado dentro de las rutas protegidas.
import FrameSuperior from "./FrameSuperior"; // [EXPERT_COMMENT]: Importación de componente - Se importa el componente FrameSuperior para ser renderizado dentro de las rutas protegidas.

const ProtectedRoute = ({
  children,
  language,
  setLanguageHandler,
  isMenuVisible,
  onToggleMenu,
}) => {
  // [EXPERT_ANALYSIS]: Añadir log de depuración - Se añade un console.log para verificar si el componente ProtectedRoute se está renderizando.
  // [EXPERT_ANALYSIS]: Razón - Permite confirmar si el flujo de la aplicación pasa por este componente.
  //console.log('Renderizando componente ProtectedRoute'); // Modificado por Andres Baena
  // [EXPERT_COMMENT]: Props adicionales - Se añaden props para el manejo del idioma y la visibilidad del menú, que serán pasadas desde App.js.
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const token = localStorage.getItem("token");

  useEffect(() => {
    // [EXPERT_ANALYSIS]: Añadir log de depuración - Se añade un console.log para rastrear la ejecución del useEffect.
    // [EXPERT_ANALYSIS]: Razón - Permite verificar cuándo se inicia la verificación del token.
    console.log("useEffect en RutasProtegidas.jsx - Verificando token..."); // Modificado por Andres Baena
    const verifyToken = async () => {
      try {
        const response = await fetchWithAuth(`${API_URL}/api/verify-token`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          localStorage.removeItem("token"); // Añadir esto antes del throw
          throw new Error("Token inválido o expirado");
        }
      } catch (error) {
        console.error("Error de verificación:", error.message); // [EXPERT_FIX]: Log de depuración añadido y se elimina la condición para el log.
        localStorage.removeItem("token");
        setIsLoading(false); // [EXPERT_FIX]: Asegurar que el cargador se detenga en caso de error
      } finally {
        setIsLoading(false);
      }
    };

    if (token) {
      // [EXPERT_ANALYSIS]: Añadir log de depuración - Se añade un console.log para indicar que se encontró un token.
      // [EXPERT_ANALYSIS]: Razón - Ayuda a confirmar si la aplicación detecta un token en localStorage.
      console.log("Token encontrado, verificando..."); // Modificado por Andres Baena
      verifyToken();
    } else {
      // [EXPERT_ANALYSIS]: Añadir log de depuración - Se añade un console.log para indicar que no se encontró un token.
      // [EXPERT_ANALYSIS]: Razón - Ayuda a confirmar si la aplicación no detecta un token en localStorage.
      console.log("No se encontró token, redirigiendo a login..."); // Modificado por Andres Baena
      setIsLoading(false);
    }
  }, [token]);

  if (isLoading) {
    return <div>Cargando...</div>;
  }

  if (!token) {
    // [EXPERT_ANALYSIS]: Añadir log de depuración - Se añade un console.log antes de la redirección.
    // [EXPERT_ANALYSIS]: Razón - Confirma que la redirección a /login se está ejecutando.
    console.log("Redirigiendo a /login desde RutasProtegidas.jsx"); // Modificado por Andres Baena
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <div className="App">
      {" "}
      {/* [EXPERT_COMMENT]: Contenedor principal - Se envuelven los componentes en un div para el layout de las rutas protegidas. */}
      <Menu
        language={language}
        setLanguageHandler={setLanguageHandler}
        isVisible={isMenuVisible}
        onToggleMenu={onToggleMenu}
      />
      <FrameSuperior />
      <Outlet />{" "}
      {/* [EXPERT_COMMENT]: Renderizado de rutas protegidas - Se reemplaza 'children' por 'Outlet' para que las rutas anidadas se rendericen correctamente. */}
    </div>
  );
};

export default ProtectedRoute;
